import { Injectable, inject } from '@angular/core';
import { ConnectorService } from 'src/app/shared/services/connector.service';

@Injectable({
  providedIn: 'root',
})
export class DynamicPriceChartDialogService {
  private connectorService = inject(ConnectorService);

  getPriceChartData(connectorIdentifier: string) {
    return this.connectorService.getPriceChartData(connectorIdentifier);
  }
}
